/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconClockBackwardCircleArrow(
  props: SVGProps<SVGSVGElement>
): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 16 16"
      color="currentColor"
      {...props}
    >
      <path
        fill="currentColor"
        d="M1.735 2.045c2.952-2.57 7.47-2.77 10.669-.298 3.568 2.759 4.152 7.804 1.289 11.26C10.84 16.45 5.65 17 2.096 14.252a.624.624 0 0 1 .763-.986c3.03 2.343 7.455 1.865 9.874-1.054 2.407-2.906 1.926-7.145-1.092-9.479C8.918.63 5.07.802 2.563 2.977h1.184a.623.623 0 0 1 0 1.246H1.112A.623.623 0 0 1 .489 3.6V1.027a.624.624 0 0 1 1.246 0zm5.336 2.61c.343 0 .622.278.622.622v2.817l1.904.742a.624.624 0 0 1-.451 1.161l-2.302-.895a.62.62 0 0 1-.397-.581V5.277c0-.344.28-.623.624-.623"
      />
    </svg>
  );
}
